(() => {
  if (window.unityWishlistInitialized) return;
  window.unityWishlistInitialized = true;
  const messages = JSON.parse(document.getElementById('UnityWishlistMessages').textContent);
  const key = 'unity:wishlist:v1';
  const dialog = document.getElementById('UnityWishlistDialog');
  const list = dialog.querySelector('[data-unity-wishlist-list]');
  const empty = dialog.querySelector('[data-unity-wishlist-empty]');
  const status = document.querySelector('[data-unity-wishlist-status]');
  let timer;
  let previousOverflow;
  const safeUrl = (value, image = false) => {
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (!image && url.origin !== location.origin) return '';
      return url.href;
    } catch { return ''; }
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(value)) return [];
      const seen = new Set();
      return value.filter(item => {
        if (!item || !/^\d+$/.test(String(item.id)) || !/^[a-z0-9-]+$/.test(item.handle) || typeof item.title !== 'string' || seen.has(String(item.id))) return false;
        seen.add(String(item.id));
        return true;
      }).slice(0, 300);
    } catch { return []; }
  };
  const announce = text => {
    clearTimeout(timer);
    status.textContent = text;
    timer = setTimeout(() => { status.textContent = ''; }, 3000);
  };
  const sync = () => {
    const ids = new Set(read().map(item => String(item.id)));
    document.querySelectorAll('[data-unity-wishlist-open]').forEach(button => {
      button.classList.toggle('unity-wishlist-has-items', ids.size > 0);
    });
    document.querySelectorAll('[data-unity-wishlist-toggle]').forEach(button => {
      const active = ids.has(button.dataset.productId);
      const text = active ? messages.saved : messages.save;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? messages.remove : messages.save}: ${button.dataset.productTitle}`);
      const label = button.querySelector('[data-unity-wishlist-label]');
      if (label && label.textContent !== text) label.textContent = text;
    });
  };
  const render = () => {
    const items = read();
    list.replaceChildren();
    empty.hidden = items.length > 0;
    const root = messages.root.replace(/\/$/, '');
    items.forEach(item => {
      const row = document.createElement('li');
      row.className = 'unity-wishlist-item';
      const imageLink = document.createElement('a');
      const href = `${root}/products/${encodeURIComponent(item.handle)}`;
      imageLink.href = href;
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      const image = document.createElement('img');
      const imageUrl = safeUrl(item.image, true);
      if (imageUrl) image.src = imageUrl;
      image.alt = '';
      image.width = 86;
      image.height = 110;
      image.loading = 'lazy';
      imageLink.append(image);
      const link = document.createElement('a');
      link.href = href;
      link.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'unity-wishlist-remove';
      remove.dataset.unityWishlistRemove = item.id;
      remove.setAttribute('aria-label', `${messages.remove}: ${item.title}`);
      remove.textContent = '×';
      row.append(imageLink, link, remove);
      list.append(row);
    });
  };
  const write = (items, message) => {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      sync();
      if (dialog.open) render();
      announce(message);
      return true;
    } catch { announce(messages.error); return false; }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-unity-wishlist-toggle], [data-unity-wishlist-open], [data-unity-wishlist-close], [data-unity-wishlist-remove]');
    if (!target) return;
    event.preventDefault();
    if (target.hasAttribute('data-unity-wishlist-toggle')) {
      const items = read();
      const id = target.dataset.productId;
      const active = items.some(item => String(item.id) === id);
      const next = active ? items.filter(item => String(item.id) !== id) : [{id, handle: target.dataset.productHandle, title: target.dataset.productTitle, image: target.dataset.productImage}, ...items];
      write(next, active ? messages.removed : messages.added);
    } else if (target.hasAttribute('data-unity-wishlist-open')) {
      render();
      if (!dialog.open) {
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
    } else if (target.hasAttribute('data-unity-wishlist-close')) {
      dialog.close();
    } else {
      const buttons = [...list.querySelectorAll('[data-unity-wishlist-remove]')];
      const index = buttons.indexOf(target);
      if (write(read().filter(item => String(item.id) !== target.dataset.unityWishlistRemove), messages.removed)) {
        const next = list.querySelectorAll('[data-unity-wishlist-remove]');
        (next[Math.min(index, next.length - 1)] || dialog.querySelector('[data-unity-wishlist-close]')).focus();
      }
    }
  });
  dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { sync(); if (dialog.open) render(); } });
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-unity-wishlist-toggle], [data-unity-wishlist-open]') || node.querySelector('[data-unity-wishlist-toggle], [data-unity-wishlist-open]'))))) return;
    pending = true;
    queueMicrotask(() => { pending = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  sync();
})();
